import { useState } from "react";
import { Copy, Loader2, Mail, MessageCircle, Share2, X } from "lucide-react";
import { toast } from "sonner";

const BASE = process.env.REACT_APP_BACKEND_URL;

export default function ShareOrderForm({ client, slug, child, schoolName }) {
  const [busy, setBusy] = useState(false);
  const [link, setLink] = useState(null);

  const message = (l) => `Bonjour ! L'école ${schoolName} organise une vente de miels et douceurs Pétales de Miel${child ? ` au profit de la classe de ${child.first} (${child.class})` : ""}. Commandez et payez en ligne ici : ${l.order}\nOu imprimez le bon de commande : ${l.pdf}`;

  const open = async () => {
    setBusy(true);
    try {
      const { data } = await client.post(`/ecoles/${slug}/bon-de-commande/share`, { child_id: child?.id || "" });
      setLink({ pdf: `${BASE}${data.path}`, order: `${window.location.origin}${data.order_path}` });
    } catch { toast.error("Création du lien impossible"); }
    finally { setBusy(false); }
  };

  const copy = async () => {
    try { await navigator.clipboard.writeText(message(link)); toast.success("Message et lien copiés"); }
    catch { toast.error("Copie impossible"); }
  };

  const nativeShare = () => navigator.share({ title: "Bon de commande Pétales de Miel", text: message(link) }).catch(() => {});
  const item = "flex items-center gap-2 rounded-xl px-3 py-2.5 text-sm font-medium text-bark transition-colors hover:bg-amber-50";

  return (
    <div className="relative">
      <button data-testid="parent-share-order-form" onClick={link ? () => setLink(null) : open} disabled={busy}
        className="flex items-center gap-2 rounded-full bg-amber-deep px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-honey disabled:opacity-60">
        {busy ? <Loader2 size={15} className="animate-spin" /> : <Share2 size={15} />} Partager
      </button>
      {link && (
        <div data-testid="share-menu" className="absolute right-0 z-30 mt-2 w-64 rounded-2xl border border-amber-800/15 bg-white p-2 shadow-xl">
          <div className="flex items-center justify-between px-3 pb-1 pt-1">
            <p className="text-xs font-semibold uppercase tracking-wider text-stone-mute">Envoyer à un proche</p>
            <button data-testid="share-close" onClick={() => setLink(null)} aria-label="Fermer" className="text-bark-soft hover:text-bark"><X size={14} /></button>
          </div>
          <a data-testid="share-whatsapp" href={`https://wa.me/?text=${encodeURIComponent(message(link))}`} target="_blank" rel="noopener noreferrer" className={item}><MessageCircle size={16} className="text-[#25D366]" /> WhatsApp</a>
          <a data-testid="share-email" href={`mailto:?subject=${encodeURIComponent(`Vente de miels — école ${schoolName}`)}&body=${encodeURIComponent(message(link))}`} className={item}><Mail size={16} className="text-amber-deep" /> E-mail</a>
          <button data-testid="share-copy" onClick={copy} className={`${item} w-full`}><Copy size={16} className="text-amber-deep" /> Copier le lien</button>
          {typeof navigator !== "undefined" && navigator.share && (
            <button data-testid="share-native" onClick={nativeShare} className={`${item} w-full`}><Share2 size={16} className="text-amber-deep" /> Autres applications…</button>
          )}
        </div>
      )}
    </div>
  );
}
